import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { FinanceiroService } from '../financeiro.service';

@Component({
  selector: 'sispac-comparar-despesas',
  templateUrl: './comparar-despesas.component.html',
  styleUrls: ['./comparar-despesas.component.css']
})
export class CompararDespesasComponent extends WebPage implements OnInit {
  public idControleLancamento: any;
  public contas: any[];
  public lancamentos: any[];
  public controleLancamento: any;

  constructor(messageService: MessageService,
    private router: Router,
    private _financeiroService: FinanceiroService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService, ) {
    super(messageService);

    this.route.paramMap.subscribe(params => {
      if (params.has('id')) {
        this.idControleLancamento = params.get('id');
      }
    });
  }

  ngOnInit() {
    this.getContas();
    this.getControleLancamento();
  }

  getControleLancamento() {
    this.isLoading = true;
    this._financeiroService.getByIdControleLancamento(this.idControleLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.controleLancamento = data;
          console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getContas() {
    this._financeiroService.getAllContas()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.contas = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getlancamentoByIdConta(idConta) {
    if (idConta === '') {
      this.lancamentos = [];
      return;
    }

    this.isLoading = true;
    this._financeiroService.getDespesasCadastradasEdital(idConta, this.idControleLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.lancamentos = data;
          console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.router.navigate(['/gerenciar-prestacao-contas']);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/comparar-despesas/comparar-despesas.component.ts